import { batchSubjectConfigurationForResultSheetQuery } from '@app-types/graphql-types';
import { HSMSSelectOption } from '@components/shared';

export const getSubjectsForSelectFromBatchSubjectConfiguration = (
  batchSubjects: batchSubjectConfigurationForResultSheetQuery['batch_subject_configuration'],
): HSMSSelectOption[] => {
  if (batchSubjects) {
    const batchSubjectsForSelect = batchSubjects.map((batchSubject) => {
      return {
        value: batchSubject.id,
        label: `${batchSubject.subject.code} - ${batchSubject.subject.name}`,
      };
    });

    return batchSubjectsForSelect.sort((firstValue, secondValue) => firstValue.label.localeCompare(secondValue.label));
  }

  return [];
};
